import { motion } from 'framer-motion';

const FloatingActions = ({ children, visible }) => {
  return (
    <motion.div
      className='fixed -bottom-1.5 md:bottom-0 left-0 right-0 w-full md:pb-4 z-50 pointer-events-none'
      initial={{ y: '100%' }}
      animate={{ y: visible ? '0%' : '100%' }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
    >
      <div className='max-w-4xl mx-auto md:px-8'>
        <div className='w-full md:rounded-full bg-gray-900 py-5 px-10 shadow-lg relative pointer-events-auto'>{children}</div>
      </div>
    </motion.div>
  );
};

export default FloatingActions;
